<template>
  <div id="app" class="g-full">
    <transition
      mode="out-in"
      enter-active-class="animated fadeIn"
      leave-active-class="animated fadeOut"
    >
      <router-view
        ondragstart="return false"
        v-on:listenToChildEvent="getChildMsg"
        style="animation-duration: 1s;"
      />
    </transition>
    <transition mode="out-in" enter-active-class="animated bounceInDown">
      <template v-if="isLogin">
        <div class="loginName">
          <div class="lab">学号</div>
          <div style="text-align: center;">{{$root.postParams.numberId}}</div>
        </div>
      </template>
    </transition>
  </div>
</template>

<script>
import { addLoginLog } from "@/api/user";
export default {
  name: "App",
  data() {
    return { isLogin: false, googleTranslation: null };
  },
  mounted: function() {
    this.checkGoogleTras();
    var ide = this.checkBrowser();
    var is360 = this.is360se();
    if (
      (!ide.webKit && !ide.ios && !ide.iPad && !ide.iPhone) ||
      is360 ||
      ide.weixin
    ) {
      this.top_wl = true;
      this.$router.push("/google");
      return;
    }
    this.$router.push("/welcome");
    //登记学号
    if (this.$root.postParams.numberId) {
      let _this = this;
      this.$store.commit(this.$store.state.mutatinTypes.SETLOGIN, {
        num: this.$root.postParams.numberId,
        eid: this.$root.postParams.eid
      });
      setTimeout(() => {
        _this.isLogin = true;
      }, 1500);
    }
    this.loginLog(
      this.$root.postParams.numberId == null
        ? ""
        : this.$root.postParams.numberId
    );
  },
  methods: {
    getChildMsg: function(data) {
      if (data == "stopRender") {
        return;
      }
      if (data == "startRender") {
        return;
      }
      this.isActive = false;
    },
    checkBrowser: function() {
      var u = navigator.userAgent,
        app = navigator.appVersion;
      return {
        trident: u.indexOf("Trident") > -1, // IE内核
        presto: u.indexOf("Presto") > -1, // opera内核
        webKit: u.indexOf("AppleWebKit") > -1, // 苹果、谷歌内核
        gecko: u.indexOf("Gecko") > -1 && u.indexOf("KHTML") == -1, // 火狐内核
        mobile: !!u.match(/AppleWebKit.*Mobile.*/), // 是否为移动终端
        ios: !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/), // ios终端
        android: u.indexOf("Android") > -1 || u.indexOf("Adr") > -1, // android终端
        iPhone: u.indexOf("iPhone") > -1, // 是否为iPhone或者QQHD浏览器
        iPad: u.indexOf("iPad") > -1, // 是否iPad
        webApp: u.indexOf("Safari") == -1, // 是否web应该程序，没有头部与底部
        weixin: u.indexOf("MicroMessenger") > -1, // 是否微信
        qq: u.match(/\sQQ/i) == " qq" // 是否QQ
      };
    },
    is360se: function() {
      var where = "suffixes",
        value = "dll",
        name = "description",
        nameReg = "vnd.chromium.remoting";
      var mimeTypes = window.navigator.mimeTypes,
        i;
      for (i in mimeTypes) {
        if (mimeTypes[i].type)
          if (mimeTypes[i].type.indexOf(nameReg) != -1) return true;
      }
      return false;
    },
    checkGoogleTras() {
      var that = this;
      that.googleTranslation = window.setInterval(() => {
        var tip = $("#trans-tooltip");
        if (tip.length == 0) {
          clearInterval(that.googleTranslation);
        } else {
          tip.parent().empty();
        }
      }, 5000);
    },
    loginLog(num) {
      addLoginLog(num, returnCitySN["cip"], returnCitySN["cname"])
        .then(response => {})
        .catch(error => {
          console.log("addLoginLog: " + error);
        });
    }
  }
};
</script>
<style lang='scss' scoped>
.backImg {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: -999;
}

.loginName {
  position: absolute;
  top: 0;
  background-color: rgba(183, 86, 22, 0.5);
  right: 5vmax;
  padding: 0.5vmax 1vmax 0.5vmax 1vmax;
  align-items: center;
  border-radius: 0px 0px 5px 5px;
  font-size: 1vmax;
  color: white;
  letter-spacing: 1px;
  min-width: 5vmax;
  .lab {
    background-color: #b75616;
    border-radius: 2px;
    width: 100%;
    padding-top: 2px;
    padding-bottom: 2px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 1vmin;
  }
}
</style>

